export default {"src":"/_next/static/media/microchip_24.94321a6e.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};